<template>
  <v-layout align-center class="cookies-policy" v-if="!cookiesPolicyAccepted && cookiePolicy">
    <v-flex data-qe-id="cookie-policy-statement" v-html="cookiePolicy">
    </v-flex>
    <v-flex>
      <v-btn class="secondary_btn" data-qe-id="accept-cookie-policy" @click="acceptCookie()">
        {{ypoCookiePolicyConstant.ACCEPT_COOKIES}}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { ypoCookiePolicyConstant, getCookiePolicy } from "@/components/YpoCookiePolicy/ypoCookiePolicy.constant";

export default {
  name: 'YpoCookiePolicy',
  data: () => ({
    ypoCookiePolicyConstant,
  }),
  props: {
    cookiesPolicyAccepted: {
      type: Boolean,
      required: true,
      default: true,
    },
    cookiesPolicyLink: {
      type: String,
      required: true,
    },
    acceptCookieHandler: {
      type: Function,
      required: true,
    },
  },
  methods: {
    acceptCookie() {
      if (this.acceptCookieHandler) this.acceptCookieHandler();
    },
  },
  computed: {
    cookiePolicy() {
      return this.cookiesPolicyLink ? getCookiePolicy(this.cookiesPolicyLink) : '';
    },
  },
};
</script>

<style lang="scss">
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_commonClasses.scss';
@import '../../common/styles/_responsive.scss';

.cookies-policy {
  background: $ypo-cta-secondary;
  position: fixed;
  z-index: 100;
  bottom: 0;
  padding: 15px 10px 15px 70px;
  color: rgba($white, 0.7);
  font-size: 12px;
  line-height: normal;
  left: 0;
  width: 100%;

  a {
    font-weight: 600;
    color: $white;
    text-decoration: none;
  }

  @media (max-width: 767px) {
    padding: 10px;
    z-index: 101;
    display: block;
    text-align: center;
    font-size: 12px;
    line-height: normal;
  }
}
</style>
